import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUserContext } from '../../context/users/UserContext'
import { 
  FaTimes, 
  FaImages, 
  FaPlus, 
  FaSearch, 
  FaChevronLeft, 
  FaChevronRight,
  FaExclamationTriangle,
  FaTrash,
  FaFolderOpen
} from 'react-icons/fa';
import {countFiles, getPhotos, removePhoto} from "../../context/photos/PhotoActions";
import { validatePermissions } from '../../context/users/UserActions'
import {hasRecords} from "../../context/questions/QuestionActions";
import { 
  Card, 
  Row, 
  Col, 
  Button, 
  Form, 
  Table, 
  Modal,
  Badge
} from 'react-bootstrap'
import './Photos.css'

// todo:
// eliminar datos innecesarios de la db


// eslint-disable-next-line
export default function Photos(props) {
    const navigate = useNavigate()
    const { authenticatedUser, setAlert } = useUserContext()
    const isAdmin = validatePermissions(authenticatedUser.permissions, 'isAdmin')
    const [pag, setPag] = useState(0);
    const [maxNextPage, setMaxNextPage] = useState(0);
    const [photos, setPhotos] = useState([])
    const [categoryName, setCategoryName] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [photoToDelete, setPhotoToDelete] = useState(null);
    const [showZoomModal, setShowZoomModal] = useState(false);
    const [selectedPhoto, setSelectedPhoto] = useState(null);

    window.scrollTo({
        top: 0,
        behavior: 'auto',
    })

    useEffect(() => {
        const getPictures = async () => {
            setIsLoading(true);
            try {
            if (categoryName.length > 2) {
                const { files, totalPages } = await getPhotos(1, categoryName, pag);
                setPhotos(files);
                setMaxNextPage(totalPages);
            } else {
                const { files, totalPages } = await getPhotos(1, '', pag);
                setPhotos(files);
                setMaxNextPage(totalPages);
                }
            } catch (error) {
                setAlert({
                    message: 'Error al cargar las fotografías',
                    msgType: 'error'
                });
            } finally {
                setIsLoading(false);
            }
        };

        getPictures();
    }, [pag, categoryName]);

    const nextPage = () => {
        if((pag + 1) < maxNextPage){
            setPag(pag + 1)
        }
    }

    const prevPage = () => {
        if(pag !== 0 ){
            setPag(pag - 1)
        }
    }

    const handleSearch = (e) => {
        const value = e.target.value
        setCategoryName(value);
        setPag(0); // Reset pagination when searching
    }

    const handleDeleteClick = (photo) => {
        if (!isAdmin) return
        setPhotoToDelete(photo);
        setShowDeleteModal(true);
    }

    const handleCloseModal = () => {
        setShowDeleteModal(false);
        setPhotoToDelete(null);
    }

    const handlePhotoClick = (photo) => {
        console.log('Photo clicked:', photo);
        setSelectedPhoto(photo);
        setShowZoomModal(true);
    }

    const handleCloseZoomModal = () => {
        setShowZoomModal(false);
        setSelectedPhoto(null);
    }

    const confirmDelete = async () => {
        if (!isAdmin || !photoToDelete) return;

        try {
            let hasRecord = await hasRecords({ 
                path: 'file',
                fileId: photoToDelete.fileName,
            token: authenticatedUser.value
            });

        if(hasRecord.hasRecords && hasRecord.noRecords > 0) {
            setAlert({
                message: "No se puede borrar la imagen porque tiene registros asociados",
                msgType: 'warning'
                });
                handleCloseModal();
            return;
        }

            let response = await removePhoto(photoToDelete.fileName);

        if(Object.prototype.hasOwnProperty.call(response, 'response')) {
            setAlert({
                message: `Imagen borrada exitosamente`,
                msgType: 'success'
                });
                // Refresh photos
                const { files, totalPages } = await getPhotos(1, categoryName, pag);
                setPhotos(files);
                setMaxNextPage(totalPages);
        } else {
            setAlert({
                message: response.message,
                msgType: 'warning'
                });
            }
        } catch (error) {
            setAlert({
                message: 'Error al eliminar la imagen',
                msgType: 'error'
            });
        } finally {
            handleCloseModal();
        }
    }

    return (
        <div className="photos-container">
            <div className="container">
                {/* Header Section */}
                <div className="photos-header">
                    <div className="header-content">
                        <div className="header-icon">
                            <FaImages />
                        </div>
                        <div className="header-text">
                            <h1>Fotografías</h1>
                            <p>Gestiona tu catálogo de imágenes y categorías</p>
                        </div>
                        </div>
                        </div>

                {/* Actions Card */}
                <Card className="actions-card">
                    <Card.Body>
                        <Row className="align-items-center">
                            {isAdmin && (
                              <>
                            <Col lg={3} md={6} sm={12} className="mb-3 mb-lg-0">
                                <Button 
                                    variant="primary" 
                                    className="add-photo-btn"
                                    onClick={() => navigate('/fotografias/agregar')}
                                >
                                    <FaPlus />
                                    Agregar Fotografía
                                </Button>
                            </Col>
                            <Col lg={3} md={6} sm={12} className="mb-3 mb-lg-0">
                                <Button 
                                    variant="outline-primary" 
                                    className="categories-btn"
                                    onClick={() => navigate('/categorias')}
                                >
                                    <FaFolderOpen className="me-2" />
                                Catálogo de Categorías
                                </Button>
                            </Col>
                              </>
                            )}
                            <Col lg={isAdmin ? 6 : 12} md={12} sm={12}>
                                <div className="search-input-container">
                                    <FaSearch className="search-icon" />
                                    <Form.Control
                                        type="text"
                                        placeholder="Buscar por categoría..."
                                        value={categoryName}
                                onChange={handleSearch}
                                        className="search-input"
                            />
                        </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Photos Table Card */}
                <Card className="table-card">
                    <Card.Body>
                        {isLoading ? (
                            <div className="loading-container">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Cargando...</span>
                                </div>
                                <p className="mt-3">Cargando fotografías...</p>
                        </div>
                        ) : photos.length === 0 ? (
                            <div className="empty-state">
                                <FaImages className="empty-icon" />
                                <h4>No se encontraron fotografías</h4>
                                <p>Intenta con otros términos de búsqueda o agrega una nueva fotografía.</p>
                    </div>
                        ) : (
                            <>
                                {/* Desktop Table View */}
                                <div className="table-responsive d-none d-lg-block">
                                    <Table className="photos-table">
                        <thead>
                        <tr>
                                                <th>Id</th>
                                                <th>Fotografía</th>
                                                <th>Categoría</th>
                                                {isAdmin && (
                                                    <th>Acciones</th>
                                                )}
                        </tr>
                        </thead>
                        <tbody>
                                            {photos.map((photo, index) => (
                                                <tr key={photo.id} className="photo-row">
                                                    <td className="photo-id">#{photo.id}</td>
                                                    <td className="photo-image">
                                                        <img
                                                            src={`https://develemosapp-file-test-e6aadvfzgyekf2bt.eastus2-01.azurewebsites.net/file/api/v1${photo.uri}`}
                                                            alt={`Fotografía ${photo.id}`}
                                                            className="photo-thumbnail clickable"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                console.log('Image clicked:', photo);
                                                                handlePhotoClick(photo);
                                                            }}
                                                            onMouseDown={(e) => {
                                                                e.preventDefault();
                                                            }}
                                                            title="Hacer clic para ver en grande"
                                                            style={{ pointerEvents: 'auto' }}
                                                        />
                                                    </td>
                                                    <td className="photo-category">
                                                        <Badge bg="secondary">{photo.category.categoryName}</Badge>
                                                    </td>
                                                    {isAdmin && (
                                                        <td className="photo-actions">
                                                            <Button
                                                                variant="outline-danger"
                                                                size="sm"
                                                                onClick={() => handleDeleteClick(photo)}
                                                                className="delete-btn"
                                                                title="Eliminar fotografía"
                                                            >
                                                                <FaTrash />
                                                            </Button>
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>

                                {/* Tablet Table View */}
                                <div className="table-responsive d-none d-md-block d-lg-none">
                                    <Table className="photos-table">
                                        <thead>
                                            <tr>
                                                <th>Fotografía</th>
                                                <th>Categoría</th>
                                                {isAdmin && (
                                                    <th>Acciones</th>
                                                )}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {photos.map((photo, index) => (
                                                <tr key={photo.id} className="photo-row">
                                                    <td className="photo-image">
                                                        <img
                                                            src={`https://develemosapp-file-test-e6aadvfzgyekf2bt.eastus2-01.azurewebsites.net/file/api/v1${photo.uri}`}
                                                            alt={`Fotografía ${photo.id}`}
                                                            className="photo-thumbnail clickable"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                console.log('Image clicked:', photo);
                                                                handlePhotoClick(photo);
                                                            }}
                                                            onMouseDown={(e) => {
                                                                e.preventDefault();
                                                            }}
                                                            title="Hacer clic para ver en grande"
                                                            style={{ pointerEvents: 'auto' }}
                                                        />
                                                    </td>
                                                    <td className="photo-category">
                                                        <Badge bg="secondary">{photo.category.categoryName}</Badge>
                                                    </td>
                                                    {isAdmin && (
                                                        <td className="photo-actions">
                                                            <Button
                                                                variant="outline-danger"
                                                                size="sm"
                                                                onClick={() => handleDeleteClick(photo)}
                                                                className="delete-btn"
                                                                title="Eliminar fotografía"
                                                            >
                                                                <FaTrash />
                                                            </Button>
                                    </td>
                                                    )}
                            </tr>
                        ))}
                        </tbody>
                                    </Table>
                                </div>

                                {/* Mobile Card View */}
                                <div className="photos-cards d-block d-md-none">
                                    {photos.map((photo, index) => (
                                        <Card key={photo.id} className="photo-card">
                                            <Card.Body className="photo-card-body">
                                                <div className="photo-card-content">
                                                    <div className="photo-info">
                                                        <div className="photo-avatar">
                                                            <div className="avatar-circle">
                                                                <span className="avatar-text">#{photo.id}</span>
                                                            </div>
                                                        </div>
                                                        <div className="photo-details">
                                                            <div className="photo-category-mobile">
                                                                <Badge bg="secondary">{photo.category.categoryName}</Badge>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="photo-image-mobile">
                                                        <img
                                                            src={`https://develemosapp-file-test-e6aadvfzgyekf2bt.eastus2-01.azurewebsites.net/file/api/v1${photo.uri}`}
                                                            alt={`Fotografía ${photo.id}`}
                                                            className="photo-thumbnail-mobile clickable"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                console.log('Image clicked:', photo);
                                                                handlePhotoClick(photo);
                                                            }}
                                                            onMouseDown={(e) => {
                                                                e.preventDefault();
                                                            }}
                                                            title="Hacer clic para ver en grande"
                                                            style={{ pointerEvents: 'auto' }}
                                                        />
                                                    </div>
                                                    {isAdmin && (
                                                        <div className="photo-actions-mobile">
                                                            <Button
                                                                variant="outline-danger"
                                                                size="sm"
                                                                onClick={() => handleDeleteClick(photo)}
                                                                className="delete-btn-mobile"
                                                                title="Eliminar fotografía"
                                                            >
                                                                <FaTrash />
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </div>
                            </>
                        )}
                    </Card.Body>
                </Card>

                {/* Pagination */}
                {photos.length > 0 && (
                    <div className="pagination-container">
                        <div className="pagination-wrapper">
                            {/* Previous Page */}
                            <button 
                                className={`pagination-nav ${pag === 0 ? 'disabled' : ''}`}
                                onClick={prevPage}
                                disabled={pag === 0}
                                title="Página anterior"
                            >
                                <FaChevronLeft />
                            </button>
                            
                            {/* Page Numbers */}
                            <div className="page-numbers">
                                <button className="page-number active">
                                    {pag + 1}
                                </button>
                            </div>
                            
                            {/* Next Page */}
                            <button 
                                className={`pagination-nav ${pag + 1 === maxNextPage ? 'disabled' : ''}`}
                                onClick={nextPage}
                                disabled={pag + 1 === maxNextPage}
                                title="Página siguiente"
                            >
                                <FaChevronRight />
                            </button>
                        </div>
                </div>
                )}
            </div>

            {/* Photo Zoom Modal */}
            <Modal show={showZoomModal} onHide={handleCloseZoomModal} centered size="lg" className="zoom-modal">
                <Modal.Header closeButton className="zoom-modal-header">
                    <Modal.Title className="zoom-modal-title">
                        <FaImages className="me-2" />
                        Vista Ampliada
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="zoom-modal-body">
                    {selectedPhoto && (
                        <div className="zoom-photo-container">
                            <img
                                src={`https://develemosapp-file-test-e6aadvfzgyekf2bt.eastus2-01.azurewebsites.net/file/api/v1${selectedPhoto.uri}`}
                                alt={`Fotografía ${selectedPhoto.id}`}
                                className="zoom-photo"
                            />
                            <div className="photo-info-zoom">
                                <p className="photo-id-zoom">
                                    <strong>ID:</strong> #{selectedPhoto.id}
                                </p>
                                <p className="photo-category-zoom">
                                    <strong>Categoría:</strong> {selectedPhoto.category.categoryName}
                                </p>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="zoom-modal-footer">
                    <Button variant="secondary" onClick={handleCloseZoomModal}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={handleCloseModal} centered className="delete-modal">
                <Modal.Header closeButton className="delete-modal-header">
                    <Modal.Title className="delete-modal-title">
                        <div className="modal-icon-container">
                            <FaExclamationTriangle className="modal-warning-icon" />
                        </div>
                        <div>
                            <h5 className="modal-title-text">Confirmar Eliminación</h5>
                            <p className="modal-subtitle">Esta acción es permanente</p>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                
                <Modal.Body className="delete-modal-body">
                    {photoToDelete && (
                        <div className="photo-preview">
                            <h6 className="preview-label">Fotografía a eliminar:</h6>
                            <div className="photo-content">
                                <img
                                    src={`https://develemosapp-file-test-e6aadvfzgyekf2bt.eastus2-01.azurewebsites.net/file/api/v1${photoToDelete.uri}`}
                                    alt="Vista previa"
                                    className="preview-image"
                                />
                                <div className="photo-details">
                                    <p className="photo-text">
                                        <strong>ID:</strong> #{photoToDelete.id}
                                    </p>
                                    <p className="photo-text">
                                        <strong>Categoría:</strong> {photoToDelete.category.categoryName}
                                    </p>
                                </div>
                </div>
            </div>
                    )}
                    
                    <div className="warning-message">
                        <FaExclamationTriangle className="warning-icon" />
                        <p>¿Estás seguro de que quieres eliminar esta fotografía? Esta acción es permanente y no se puede deshacer.</p>
                    </div>
                </Modal.Body>
                
                <Modal.Footer className="delete-modal-footer">
                    <Button 
                        variant="outline-secondary" 
                        onClick={handleCloseModal}
                        className="cancel-delete-btn"
                    >
                        Cancelar
                    </Button>
                    <Button 
                        variant="danger" 
                        onClick={confirmDelete}
                        className="confirm-delete-btn"
                    >
                        <FaTrash className="me-2" />
                        Eliminar Fotografía
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
